// import {createTheme} from '@mui/material/styles';
import {
    experimental_extendTheme as extendTheme,
} from '@mui/material/styles';

// Color palette — single source of truth
// Background gradient endpoints
const bgGradientStart = '#393261';
const bgGradientEnd = '#1e213a';
// Surface layers (lightest → darkest)
const surfaceDeep = '#110e20';      // inputs, search bar
const surfaceBase = '#1b1730';      // main content area
const surfaceElevated = '#282247';  // player, cards
const surfaceOverlay = '#342e5c';   // dialogs, popovers — clearly distinct from background
// Accent
const accent = '#f4d160';
// White overlays
const whiteOverlay8 = 'rgba(255, 255, 255, 0.08)';
const whiteOverlay10 = 'rgba(255, 255, 255, 0.1)';
const whiteOverlay20 = 'rgba(255, 255, 255, 0.2)';

const theme = extendTheme({
    colorSchemes: {
        light: {
            palette: {
                action: {
                  active: '#ffffff',
                },
                background: {
                  default: bgGradientEnd,
                  paper: surfaceBase,
                },
                divider: whiteOverlay10,
                primary: {
                    main: '#9e97c7',
                    contrastText: '#ffffff',
                },
                secondary: {
                    main: accent,
                },
                text: {
                    primary: '#ffffff',
                    secondary: accent,
                },
            },
        }
    },
    typography: {
        fontFamily: [
            'Karla',
            'Raleway',
            'Roboto',
            'Helvetica Neue',
            'Arial',
            'sans-serif'
        ].join(','),
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    background: `linear-gradient(135deg, ${bgGradientStart}, ${bgGradientEnd})`,
                },
            },
        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    backgroundColor: surfaceOverlay,
                    backgroundImage: 'none',
                    border: `1px solid ${whiteOverlay10}`,
                    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.5)',
                },
            },
        },
        MuiMenu: {
            styleOverrides: {
                paper: {
                    backgroundColor: surfaceOverlay,
                    backgroundImage: 'none',
                    border: `1px solid ${whiteOverlay10}`,
                },
            },
        },
        MuiPopover: {
            styleOverrides: {
                paper: {
                    backgroundColor: surfaceOverlay,
                    backgroundImage: 'none',
                },
            },
        },
    },
});

// Export palette constants for use in SCSS via CSS custom properties
export const palette = {
    bgGradientStart,
    bgGradientEnd,
    surfaceDeep,
    surfaceBase,
    surfaceElevated,
    surfaceOverlay,
    accent,
    whiteOverlay8,
    whiteOverlay10,
    whiteOverlay20,
};

export default theme;
